// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"e4aa55e1","453":"b28f2a56","934":"f8a4fba3"}[chunkId] + ".chunk.js";
};